module.exports = __webpack_public_path__ + "static/img/chrome_img_4.923f4568.png";